import { z } from "zod";
import { DbCreateInputOmit } from "../../../helpers/db";
import { DocumentationPageApprovalState } from "../approvals/approval-state";

export const DocumentationPageApproval = z.object({
  id: z.string(),
  approvalState: DocumentationPageApprovalState,
  persistentId: z.string(),
  pageId: z.string(),
  pagePersistentId: z.string(),
  updatedByUserId: z.string(),
  designSystemVersionId: z.string(),
  updatedAt: z.coerce.date(),
  createdAt: z.coerce.date(),
});

export type CreateDocumentationPageApproval = DbCreateInputOmit<DocumentationPageApproval>;
export type DocumentationPageApproval = z.infer<typeof DocumentationPageApproval>;
